/* global Vue, window */

const menu = new Vue({
  el: '#menu',
  data: () => ({
    width: 0,
    showMenu: false,
  }),
  computed: {
    menuVisible: function() {
      return (this.width > 1023 || this.showMenu);
    },
    menuToggleVisible: function() {
      return this.width < 1024;
    },
    menuClass: function() {
      return 'menu menu-is-' + (this.menuVisible ? 'visible' : 'hidden');
    },
    menuToggleButtonClass: function() {
      return 'menu-toggle menu-is-' + (this.menuVisible ? 'visible' : 'hidden');
    },
  },
  methods: {
    resize: function() {
      window.requestAnimationFrame(this.updateWidth);
    },
    updateWidth: function() {
      this.width = window.innerWidth;
    },
    toggleMenu: function() {
      this.showMenu = this.showMenu ? false : true;
    },
  },
  created: function() {
    this.width = window.innerWidth;
    window.addEventListener('resize', this.resize);
  },
});
